import styled from '@emotion/styled';
import { BreakpointsEnum } from '../../../../helpers/breakpoints';

export const CruisePageSectionHeader = styled.div`
    color: ${({ theme }) => theme.productPage.sectionHeader.textColor};
    width: 100%;
    font-size: 16px;
    font-weight: bold;
    padding: 12px 24px;
    margin-top: 24px;
    background-color: ${({ theme }) => theme.productPage.sectionHeader.backgroundColor};
    border-radius: 6px 6px 0 0;
    display: none;

    &.fullMode {
        display: block;
        border-radius: 0;
        margin-top: 0px;
    }
    @media (min-width: ${BreakpointsEnum.md}) {
        display: inline-block;
    }
`;
